import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, EventEmitter, inject, input, output, TemplateRef, viewChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { AnimationService } from 'src/app/infrastructure/services/loading-services/animation.service';
import { ButtonsGroupComponent } from '../../../footer/components/buttons-group/buttons-group.component';
import { _CentralPageService } from '../../services/_central-page.service';
import { CompositePageComponent } from '../composite-page/composite.component';
import { FooterService } from '../../../footer/footer.service';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { SectionDetailsComponent } from '../section-details/section-details.component';
import { SectionDetailsTabLayoutComponent } from '../section-details-tab-layout/section-details-tab-layout.component';
import { SharedModule } from '../../../shared.module';
import { centralPageAnimation } from 'src/app/infrastructure/animations/central-page-animations';
import { showAnimation } from 'src/app/infrastructure/animations/show-animation';
import { slideAnimation } from 'src/app/infrastructure/animations/slide-animation';
import { pageMode } from 'src/app/infrastructure/models/page-mode';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Component({
    selector: 'app-single-page',
    templateUrl: './single-page.component.html',
    styleUrls: [
        '../../central-page.scss',
        './single-page.component.scss',
    ],
    host: {
        '[class]': '`single-page central-page ${pageLayout$$()}-layout ${pageMode$$()}-mode`',
    },
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    standalone: true,
    imports: [
        ButtonsGroupComponent,
        CompositePageComponent,
        NgTemplateOutlet,
        SectionDetailsComponent,
        SectionDetailsTabLayoutComponent,
        SharedModule,
    ],
    animations: [
        slideAnimation,
        showAnimation,
        centralPageAnimation,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SinglePageComponent
{
    protected readonly _animationService = injectRequired(AnimationService);
    protected readonly _centralPageService = injectRequired(_CentralPageService);
    protected readonly _footerService = injectRequired(FooterService);
    protected readonly _loadingPageService = injectRequired(LoadingPageService);

    loadingPage$$ = computed(() => this._loadingPageService.isLoading$$());
    pageLayout$$ = this._centralPageService.pageLayout$$;
    pageMode$$ = this._centralPageService.pageMode$$;

    sectionDetails_buttons_template$$ = this._centralPageService.sectionDetails_buttons_template$$;
    sectionDetails_show$$ = computed(() => this._centralPageService.pageMode$$() == pageMode.detailsPage);
    sectionEdit_buttons_template$$ = this._centralPageService.sectionEdit_buttons_template$$;
    sectionEdit_show$$ = computed(() => this._centralPageService.pageMode$$() == pageMode.editPage || this._centralPageService.pageMode$$() == pageMode.createPage);
    
    footerContentBlock$$ = viewChild<TemplateRef<any>>('footerContentBlock');

    tabLayout$$ = input(false, {alias: 'tabLayout'})

    btnCancelData$$ = this._centralPageService.btnCancelData$$;
    btnDeleteData$$ = this._centralPageService.btnDeleteData$$;
    btnEditData$$ = this._centralPageService.btnEditData$$;
    btnSaveData$$ = this._centralPageService.btnSaveData$$;
    
    btnDeleteEmit = output({alias: 'btnDelete'});
    btnEditEmit = output({alias: 'btnEdit'});
    btnCancelEmit = output({alias: 'btnCancel'});
    btnSaveEmit = output({alias: 'btnSave'});

    constructor() {
        effect(() => this._footerService.contentBlock_template_set(this.footerContentBlock$$()))
    }

    emit_bntCancel(): void {
        this.btnCancelEmit.emit();
    }

    emit_btnDelete(): void {
        this.btnDeleteEmit.emit();
    }

    emit_btnEdit(): void {
        this.btnEditEmit.emit();
    }

    emit_btnSave(): void {
        this.btnSaveEmit.emit();
    }

    emit_animation_start(event: Event): void {
        this._animationService.add();
    }
    
    emit_animation_end(event: Event): void {
        this._animationService.remove();
    }
}
